import React from "react";
import { Link } from "gatsby";

import Layout from "../components/layout";
import FormIndex from "../components/Form/view";

// TODO: Hente inn rapporttype
// TODO: Hente inn fylke
// TODO: Valg for rapporttype
// TODO: Valg for fylke

export default function IndexPage() {
  return (
    <Layout>
      <FormIndex />
    </Layout>
  );
}
